import type { MessageProps } from './message.types'

import { styled, useStyleConfig, vui } from '../core'
import { Icon } from '../icon'
import { T } from '../t'
import { cs } from '../utils'
import { iconDictionary, spacingDictionary } from './consts'

export const MessageBase = styled.divBox`
  transition-duration: fast;
`

/** Displays a simple message text. */
export const Message = vui<'div', MessageProps>((props, ref) => {
  const { children, className, text, size: sizeProp = 'md', intent: intentProp, variant: variantProp, ...rest } = props
  // Explicit `intent` wins; `variant` is a deprecated fallback — `error` maps to `danger`.
  const intent = (intentProp ??
    (variantProp === 'error' ? 'danger' : variantProp) ??
    'info') as keyof typeof iconDictionary
  // `lg` is removed — maps to `md`.
  const size = sizeProp === 'lg' ? 'md' : sizeProp
  const styles = useStyleConfig('Message', { variant: intent, size })

  return (
    <MessageBase className={cs('vui-message', className)} ref={ref} {...styles} {...rest}>
      <>
        <Icon mr={`${spacingDictionary[size]}px`} mt="2px" name={iconDictionary[intent]} size={styles.iconSize} />
        <T size={styles.fontSize} w="100%" variant="caption">
          {children ?? text}
        </T>
      </>
    </MessageBase>
  )
})

Message.displayName = 'Message'

export default Message
